// extracted by mini-css-extract-plugin
export default {"box":"styles_box__l1-c4","img":"styles_img__lZoFA","date":"styles_date__R+ewW","boxMobile":"styles_boxMobile__7LV7X"};